import _set from 'lodash/set';

import { MutationTree } from "vuex";
import { ContractorsState } from "./types";
import { Contractor } from "@/models";
import _ from 'lodash';

/**
 * Mutations
 *
 * The only way to actually change state in a Vuex store is by committing a mutation.
 * - Vuex mutations are very similar to events: each mutation has a string type and a handler.
 * - The handler function is where we perform actual state modifications - it receives the state as the first argument:
 * - You cannot directly call a mutation handler.
 * - Think of it more like event registration: "When a mutation with type X is triggered, call this handler."
 * - To invoke a mutation handler, you need to call store.commit with its type e.g. `store.commit('setUser', user)`
 */
export const mutations: MutationTree<ContractorsState> = {

	/**
	 * Set the Contractors list
	 * 
	 * @param {ContractorsState} state
	 * @param {Contractor[]} Contractors
	 * @returns void
	 */
	setContractors(state: ContractorsState, Contractors: Contractor[]): void {
		state.list = Contractors;
	},

	/**
	 * Set current Contractor
	 * 
	 * @param {ContractorsState} state
	 * @param {Contractor} Contractor
	 * @returns void
	 */
	setCurrent(state: ContractorsState, Contractor: Contractor): void {
		state.current = Contractor;
	},

	/**
   * Set current page
   *
   * @param state ReportsState
   * @param currentPage number
   * @returns void
   */
	setCurrentPage(state: ContractorsState, currentPage: number): void {
		state.currentPage = currentPage;
	},

	/**
	 * Set the currently edited/viewed Contractor
	 */
	setContractorsDeep(state: ContractorsState, payload: { path: string, data: any }): void {
		state.current = Object.assign(new Contractor, _set(state.current, payload.path, payload.data));
	},

	/**
	 * ++ Unsaved changes
	 * 
	 * @param state ContractorsState
	 * @param element string
	 * @returns void
	 */
	addUnsavedChange(state: ContractorsState, element: string): void {
		state.updates = [...new Set(state.updates.concat([element]))];
	},

	/**
	  * Reset Unsaved changes
	  * 
	  * @param state ContractorsState
	  * @returns void
	  */
	resetUnsavedChanges(state: ContractorsState): void {
		state.updates = [];
	},

	resetState(state: ContractorsState): void {
		state.current = new Contractor;
		state.list = [];
		state.updates = [];
	},

	rehydrateState(state: ContractorsState): void {
		state.current = new Contractor(state.current);
		state.list = state.list.map((x: any) => new Contractor(x));
	}

}
